import { Container, Typography } from "@mui/material";

export default function AppFooter() {
  return (
    <Container sx={{mt: 2}}>
        <Typography align="center" variant="body2">©2023 Jin Yubin. All rights reserved.</Typography>
    </Container>
  );
}